import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState } from 'recoil';
import { passingsForInvoicePagination } from 'api/passings/getPassingsForInvoice';
import Pagination from 'components/Pagination/Pagination';
import { Title } from 'components/Text';
import RemittanceList from 'components/RemittanceDetailsList/RemittanceList';
export default function RetmittanceDetails({
  invoiceLines
}) {
  const {
    t
  } = useTranslation();
  const [pagination, setPagination] = useRecoilState(passingsForInvoicePagination);
  let content;
  if (!!!invoiceLines || invoiceLines?.length === 0) content = /*#__PURE__*/React.createElement(Title, {
    align: "center"
  }, t('passings.no_passing'));else {
    content = /*#__PURE__*/React.createElement(RemittanceList, {
      items: invoiceLines.slice(pagination.offset, pagination.offset + pagination.max)
    });
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, content, /*#__PURE__*/React.createElement(Pagination, {
    totalResults: invoiceLines?.length ?? 0,
    handlePagination: setPagination,
    paginationParams: pagination
  }));
}